
precision highp float;
precision highp int;
precision highp sampler2D;

uniform sampler2D imageA;
uniform sampler2D imageB;
uniform float mixValue;

in vec2 vUv;
out vec4 fragColor;

void main() {
  fragColor = mix(texture(imageA, vUv), texture(imageB, vUv), mixValue);
}